import { IonButton, IonCard, IonCardContent, IonLabel } from '@ionic/react';
import React from 'react';
import { openExternalLink } from '../../../utils/openExternalLink';

interface LoginErrorCardProps {
  error: string;
  isSubscriptionError: boolean;
  onClear: () => void;
}

const LoginErrorCard: React.FC<LoginErrorCardProps> = ({
  error,
  isSubscriptionError,
  onClear,
}) => {
  return (
    <IonCard
      className="error-card"
      style={{
        margin: '0',
        boxShadow: isSubscriptionError
          ? '0 2px 8px rgba(255, 193, 7, 0.2)'
          : '0 2px 8px rgba(220, 53, 69, 0.2)',
        border: isSubscriptionError
          ? '1px solid rgba(255, 193, 7, 0.3)'
          : '1px solid rgba(220, 53, 69, 0.3)',
        borderRadius: '12px',
        background: isSubscriptionError
          ? 'rgba(255, 193, 7, 0.08)'
          : 'rgba(220, 53, 69, 0.08)',
      }}
    >
      <IonCardContent style={{ padding: '16px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '12px',
          }}
        >
          <div
            style={{
              fontSize: '20px',
              marginRight: '12px',
              marginTop: '2px',
            }}
          >
            {isSubscriptionError ? '⚠️' : '❌'}
          </div>
          <IonLabel
            style={{
              fontSize: '0.95rem',
              lineHeight: '1.4',
              color: isSubscriptionError ? '#b7691a' : '#c53030',
              fontWeight: '500',
            }}
          >
            {error}
          </IonLabel>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            alignItems: 'stretch',
          }}
        >
          <IonButton
            fill="clear"
            size="small"
            onClick={onClear}
            style={{
              '--color': isSubscriptionError ? '#b7691a' : '#c53030',
              fontSize: '0.8rem',
              textTransform: 'none',
              alignSelf: 'flex-start',
              margin: '0',
              height: '32px',
              opacity: '0.8',
            }}
          >
            ✕ Clear and try again
          </IonButton>

          {isSubscriptionError && (
            <>
              <div style={{ margin: '8px 0 4px 0' }}>
                <IonLabel
                  style={{
                    fontSize: '0.85rem',
                    color: '#b7691a',
                    fontWeight: '500',
                  }}
                >
                  Choose an action:
                </IonLabel>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '8px',
                  flexWrap: 'wrap',
                }}
              >
                <IonButton
                  fill="solid"
                  size="small"
                  color="primary"
                  onClick={() =>
                    openExternalLink('https://www.cratehackers.com/7days')
                  }
                  style={{
                    fontSize: '0.8rem',
                    textTransform: 'none',
                    flex: '1',
                    minWidth: '140px',
                  }}
                >
                  🔄 Renew Subscription
                </IonButton>
                <IonButton
                  fill="outline"
                  size="small"
                  color="warning"
                  onClick={() =>
                    openExternalLink(
                      'mailto:help@cratehackers.com?subject=Subscription Login Issue',
                    )
                  }
                  style={{
                    fontSize: '0.8rem',
                    textTransform: 'none',
                    flex: '1',
                    minWidth: '120px',
                  }}
                >
                  💬 Contact Support
                </IonButton>
              </div>
            </>
          )}
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export default LoginErrorCard;
